import {
  type EmailVerificationCommand,
  type EmailVerificationCommandResult,
  EmailVerificationCommandResultStatus,
  SignInStatus,
  postAuthVerifyEmail,
} from "Infrastructure/Api/Api";
import type { NavigateFunction } from "Navigation/useNavigate";
import { afterSignInSuccess } from "Utils/AuthUtils";
import { setToken } from "Utils/Storage/LocalStorage/LocalStorageUtils";
import { getAppUrl } from "Utils/UrlUtils";
import { call, put, takeLatest } from "typed-redux-saga";
import { createAsyncAction, getType } from "typesafe-actions";

export const verifyEmailAsync = createAsyncAction(
  "@auth/VERIFY_EMAIL_REQUEST",
  "@auth/VERIFY_EMAIL_SUCCESS",
  "@auth/VERIFY_EMAIL_FAILURE",
)<
  { command: EmailVerificationCommand; navigate: NavigateFunction },
  EmailVerificationCommandResult,
  Error
>();

function* verifyEmail(
  action: ReturnType<typeof verifyEmailAsync.request>,
): Generator {
  try {
    const response = yield* call(postAuthVerifyEmail, action.payload.command);

    if (
      response.status === 200 &&
      response.data.status === EmailVerificationCommandResultStatus.Success
    ) {
      yield put(verifyEmailAsync.success(response.data));
      if (response.data.signInResult) {
        setToken(response.data.signInResult);
      }

      if (response.data.signInResult?.status === SignInStatus.Success) {
        yield* call(
          afterSignInSuccess,
          response.data.signInResult,
          action.payload.navigate,
        );
      }

      const url = getAppUrl();
      yield* call(() => action.payload.navigate(url("dashboard")));
      // toast.success("E-mail byl úspěšně ověřen.");
    } else {
      yield* call(() => action.payload.navigate("/"));
      yield put(
        verifyEmailAsync.failure(
          new Error(`Error in action ${action.type}`, {
            cause: response.status,
          }),
        ),
      );
    }
  } catch (err) {
    yield put(verifyEmailAsync.failure(err as Error));
  }
}
export function* verifyEmailSaga() {
  yield takeLatest(getType(verifyEmailAsync.request), verifyEmail);
}
